import { api } from "@/api";
import { queryClient } from "@/queryClient";

/** Texts the customer a fresh Arrival Companion link now. */
export const sendStorageCompanionLink = async (bookingId: string) => {
  await api.post(`/storage/bookings/${bookingId}/companion-link`);
  void queryClient.invalidateQueries(["messages"]);
};
